<template>
  <PageContent tag="section">
    <template #header>
      <div class="pr-20">
        <h1 class="heading-2 m0" :id="headingId">{{ heading }}</h1>
        <div v-if="eventTypeName" class="fs-18 color-gray">{{ eventTypeName }}</div>
      </div>
      <div class="flex gap-16" v-if="canEditEvent">
        <EditEventButton v-model="event" class="btn" @save="onEventSaved"/>
		<button class="btn btn-util square-32" @click="promptConfirmCancel = true">
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path stroke="#004ADB" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.25 3.125H3.75a.625.625 0 0 0-.625.625v12.5c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625V3.75a.625.625 0 0 0-.625-.625ZM13.75 1.875v2.5M6.25 1.875v2.5M3.125 6.875h13.75"/><path stroke="#140047" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m11.875 10-3.75 3.75M11.875 13.75 8.125 10"/></svg>
		</button>
      </div>
    </template>
    <SuccessMessage :content="successMessage" />
    <ChatList heading="Messages" :chats="jobChats" no-from-filter />


	<Modal v-model="promptConfirmCancel" width="475">
		<template #content>
			<h2 class="text-center fs-22 mb-0">Cancel Job</h2>
			<p class="mt-8 fs-14 lh-22 text-center">Cancel your upcoming "{{ event.name }}" job?<br>
				<span class="color-red fw-700">This is permanent and can't be undone!</span>
			</p>
			<div class="mt-24 flex-col flex-center sm-flex-row gap-16 pb-16">
				<button class="btn btn-large btn-green" :class="{'is-processing': isCanceling}" @click="cancelJob">Yes, Cancel Job</button>
				<button class="btn btn-large" @click="promptConfirmCancel = false">No, Don't Cancel</button>
			</div>
		</template>
	</Modal>
  </PageContent>
</template>

<script>
import ChatList from '@/components/chats/ChatList';
import EditEventButton from '@/components/jobs/EditEventButton';
import { cancelJob } from '@/services/swm/api';

export default {
	name: 'JobsShowDetails',
	components: {
		ChatList,
		EditEventButton,
	},
	data() {
		return {
			isCanceling: false,
			successMessage: null,
			promptConfirmCancel: false,
		};
	},
	computed: {
		candidateState() {
			return this.$store.getters['jobs/candidateState'];
		},
		canEditEvent() {
			return this.$store.getters['jobs/canEditEvent'];
		},
		contract() {
			return this.$store.getters['jobs/contract'];
		},
		employerProfile() {
			return this.$store.getters['jobs/employerProfile'];
		},
		event: {
			get() {
				return this.$store.getters['jobs/event'];
			},
			set(event) {
				return this.$store.commit('jobs/setEvent', event);
			},
		},
		eventTypeName() {
			return this.$store.getters['jobs/eventTypeName'];
		},
		heading() {
			return this.$store.getters['jobs/heading'];
		},
		headingId() {
			return this.$store.getters['jobs/headingId'];
		},
		isEmployer() {
			return this.$store.getters['jobs/isEmployer'];
		},
		jobChats() {
			return this.$store.getters['jobs/jobChats'] || [];
		},
		showEventChanges() {
			return this.candidateState === 'awaitingChangesResponse';
		},
	},
	methods: {
		onEventSaved(event) {
			this.event = event;
			this.successMessage = 'Event updated successfully.';
		},
		async cancelJob() {
			this.isCanceling = true;
			try {
				await cancelJob(this.event.id);
				this.promptConfirmCancel = false;
				this.$router.push({ name: this.$routes.Dashboard.name });
			} catch (error) {
				console.log('cancel job error');
				this.isCanceling = false;
			}
		},
	},
	watch: {
		$route() {
			this.successMessage = null;
		},
	},
};
</script>
